import { RelatorioIncon } from './../../../_core/models/relatorio-incon';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Lotacao } from './../../../_core/models/lotacao';
import { Usuario } from 'src/app/_core/models/usuario';
import { LoginService } from 'src/app/_core/services/login.service';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { Relatorio } from './../../../_core/models/relatorio';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable'
import { Localizacao } from 'src/app/_core/models/localizacao';
import { LocalizacaoService } from 'src/app/_core/services/localizacao.service';
import { environment as env } from 'src/environments/environment';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { MovimentacaoService } from 'src/app/_core/services/movimentacao.service';
import * as fileSaver from 'file-saver';
import Swal from 'sweetalert2';
import { RelatorioBem } from 'src/app/_core/models/relatorio-bem';


@Component({
  selector: 'app-relatorio-bens',
  templateUrl: './relatorio-bens.component.html',
  styleUrls: ['./relatorio-bens.component.scss']
})
export class RelatorioBensComponent implements OnInit {
  relatorioBens: Relatorio[];
  localizacao: Localizacao[];
  localizacao_incon:Localizacao[];
  cadastro: RelatorioBem[];
  public matricula: Number;
  keywordMatricula = 'nome';
  keywordLotacao = 'dS_LOTACAO';
  keywordUnidade = 'dS_BPM_UNIDADE';
  keywordUnidadeIncon = 'dS_BPM_UNIDADE';
  keywordMeusBens = 'dS_BPM_DESCRICAO_BEM';
  keywordMatGestor = 'nome';
  keywordMatUser = 'nome';
  public localizar: Number;
  localizar_incon: Number;
  public lot: Number;
  public sala: string;
  loading = true;
  inicio: Date = new Date();
  fim: Date = new Date();
  users!: Usuario[];
  lotacao!: Lotacao[];
  form: FormGroup;
  form_incon:FormGroup;
  nR_BPM_BEM_PATRIMONIAL: number;
  cD_CDU_MATRICULA_GESTOR: number;
  cD_CDU_MATRICULA_USUARIO_CAUTELA: number;
  dS_BPM_SALA: string;
  dataGestor:Usuario[];
  // @ViewChild('pdfTable', { static: false }) pdfTable!: ElementRef;

  // public downloadAsPDF() {
  //   var img = new Image()
  //   img.src = './assets/img/Eletronorte-logo.png'


  //   const doc = new jsPDF('portrait', 'px', 'a4');
  //   autoTable(doc,
  //     {
  //       html: '#pdfTable',
  //       didDrawPage: function (data) {
  //         // Header
  //         doc.setFontSize(15);
  //         doc.setTextColor(40);
  //         doc.setFont('normal')
  //         doc.addImage(img, 'PNG', data.settings.margin.left + 10, 5, 20, 20);
  //         doc.text("Relatório de bens", data.settings.margin.top + 150, 22);
  //       },
  //       theme: 'striped'
  //     })
  //   doc.save('RelatorioBens.pdf')
  // }

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private cadastroBemService: CadastroBemService,
    private movimentacaoService: MovimentacaoService,
    private localizacaoService: LocalizacaoService) { }

  ngOnInit(): void {
    this.lot = 0;
    this.matricula = 0;
    this.localizar = 0;
    this.dS_BPM_SALA = '';
    this.cD_CDU_MATRICULA_GESTOR = 0;
    this.cD_CDU_MATRICULA_USUARIO_CAUTELA = 0;
    this.localizar_incon = 0;
    this.listarUser();
    this.listarGestor()
    this.listarLot();
    //this.listarBens();
    this.gerarFormBens();
    this.gerarFormIncon();
    this.localizacaoAll();
    this.loading = false;
  }
  gerarFormBens() {
    this.form = this.fb.group({
      cD_LOTACAO: [this.lot, []],
      cD_MATRICULA: [this.matricula, []],
      cD_BPM_NR_UNIDADE: [this.localizar, []],
      dS_BPM_SALA: [this.dS_BPM_SALA]
    });
  }
  gerarFormIncon() {
    this.form_incon = this.fb.group({
      cD_CDU_MATRICULA_GESTOR: [this.cD_CDU_MATRICULA_GESTOR, []],
      cD_CDU_MATRICULA_USUARIO_CAUTELA: [this.cD_CDU_MATRICULA_USUARIO_CAUTELA, []],
      cD_BPM_NR_UNIDADE: [this.localizar_incon, []],
      status: ['']
    });
  }
  selectMat(item: any) {
    this.matricula = item.cD_MATRICULA;
    //console.log/this.matricula)
    this.form.controls['cD_MATRICULA'].setValue(this.matricula);
  }
  selectLot(item: any) {
    this.lot = item.iD_LOTACAO;
    //console.log/this.lot)
    this.form.controls['cD_LOTACAO'].setValue(this.lot);
  }
  selectEvent(item: any) {
    this.localizar = item.cD_BPM_NR_UNIDADE;
    //console.log/this.localizar);
    this.form.controls['cD_BPM_NR_UNIDADE'].setValue(this.localizar);
  }
  selectMeusBens(item: any) {
    //console.log/item);
    const num = item.nR_BPM_BEM_PATRIMONIAL;
    this.nR_BPM_BEM_PATRIMONIAL = num;
    //console.log/this.nR_BPM_BEM_PATRIMONIAL);
  }
  selectMatGestor(item:any){
    //console.log/item);
    this.cD_CDU_MATRICULA_GESTOR = item.cD_MATRICULA;
    //console.log/this.cD_CDU_MATRICULA_GESTOR);
    this.form_incon.controls['cD_CDU_MATRICULA_GESTOR'].setValue(this.cD_CDU_MATRICULA_GESTOR)
  }
  selectMatUser(item:any){
    //console.log/item);
    this.cD_CDU_MATRICULA_USUARIO_CAUTELA = item.cD_MATRICULA;
    this.form_incon.controls['cD_CDU_MATRICULA_USUARIO_CAUTELA']
    .setValue(this.cD_CDU_MATRICULA_USUARIO_CAUTELA);
    
  }
  selectUnidade(item:any){
    this.localizar_incon = item.cD_BPM_NR_UNIDADE;
    //console.log/this.localizar_incon);
    this.form_incon.controls['cD_BPM_NR_UNIDADE']
    .setValue(this.localizar_incon);
  }
  listarGestor(){
    this.loginService.getGestor()
    .subscribe(
      data => {
        this.dataGestor = data;
        this.dataGestor.map( data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
      }
    )
  }
  listarBens() {
    this.cadastroBemService.listarBensApenas()
      .subscribe(
        data => {
          this.cadastro = data;
          this.cadastro.map(data => data.dS_BPM_DESCRICAO_BEM = ` ${data.nR_BPM_BEM_PATRIMONIAL} | ${data.dS_BPM_DESCRICAO_BEM}`);
        }
      )
  }
  localizacaoAll() {
    this.localizacaoService.localizacaoAll()
      .subscribe(
        data => {
          this.localizacao = data;
          this.localizacao_incon = data;
        }
      )
  }
  listarUser() {
    this.loginService.getAll()
      .subscribe(
        data => {
          this.users = data;
          this.users.map(data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
        }
      )
  }
  listarLot() {
    this.loginService.getLot()
      .subscribe(
        data => {
          this.lotacao = data;
          this.lotacao.map(data => data.dS_LOTACAO = ` ${data.dS_SIGLA} | ${data.dS_LOTACAO} `)
        }
      )
  }
  insertBens() {
    //console.log/this.form.value);
    this.loading = true;
    var relatorio: Relatorio = this.form.value;
    relatorio.dS_BPM_SALA = this.dS_BPM_SALA;
    console.log(relatorio);
    this.cadastroBemService.getRelatorioBens(relatorio)
      .subscribe(
        response => {
          // var blob: any = new Blob([response], { type: "application/octet-stream" });
          // const url = window.URL.createObjectURL(blob);
          // window.open(url);
          // window.location.href = response.url;
          fileSaver.saveAs(response,'relatorio_de_bens.xlsx');
          this.ngOnInit();
          this.loading = false;
        },
        err => {
          Swal.fire(
            'Erro!',
            'Operação não Realizada!',
            'warning'
          ).then(() => {
            this.loading = false;
            this.ngOnInit();
          });
        }
      )
  }
  insertMov() {
    this.movimentacaoService.mov_getRelatorio(this.nR_BPM_BEM_PATRIMONIAL)
      .subscribe(
        response => {
          // let blob: any = new Blob([response], { type: "application/octet-stream" });
          // const url = window.URL.createObjectURL(blob);
          // window.open(url);
          // window.location.href = response.url;
          fileSaver.saveAs(response,'relatorio_de_movimentacao.xlsx');
          this.ngOnInit();
          this.loading = false;
        },
        err => {
          Swal.fire(
            'Bem não existe!',
            'Operação não Realizada!',
            'warning'
          ).then(() => {
            this.ngOnInit();
            this.loading = false;
          });
        }
      );
  }
  insertIncon() {
    var relatorioIncon:RelatorioIncon = this.form_incon.value;
    relatorioIncon.status = Number(relatorioIncon.status);
    //console.log/relatorioIncon);
    this.movimentacaoService.mov_incon_getRelatorio(relatorioIncon)
    .subscribe(
      response => {
        // let blob: any = new Blob([response], { type: "application/octet-stream" });
        // const url = window.URL.createObjectURL(blob);
        // window.open(url);
        // window.location.href = response.url;
        fileSaver.saveAs(response,'relatorio_de_inconsistencia.xlsx');
        this.ngOnInit();
        this.loading = false;
      },
      err => {
        //console.log/err);
        this.ngOnInit();
      }
    );

  }

}

